module.exports = __webpack_public_path__ + "static/media/selo-dryaged.bc2d585a.png";